/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions, getStateFromPath } from "@react-navigation/native";
import * as Linking from "expo-linking";
import { Platform } from "react-native";
import { RootStackParamList } from "./Navigation.types";

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [Linking.createURL("/")],
  enabled: Platform.OS !== "android",
  config: {
    screens: {
      "not-found": "*",
      login: "auth/login",
      "set-password": "auth/set-password",
      "forgot-password": "auth/forgot-password",
      "reset-password": "auth/reset-password",
      main: {
        path: "",
        screens: {
          home: "schedule",
          "my-games": "my-games",
          stats: "rankings",
          game: "game",
        },
      },
      vote: "vote",
    },
  },
  getStateFromPath: (path, options) => {
    if (Platform.OS !== "web" || (!path.startsWith("/auth/set-password") && !path.startsWith("/auth/reset-password")))
      return getStateFromPath(path, options);

    const webPath = window.location.hash;

    // Extract parameters from the hash and return them as route.params
    const params =
      webPath
        .replace("#", "")
        .split("&")
        .reduce((acc: any, param: string) => {
          const [key, value] = param.split("=");
          acc[key] = value;
          return acc;
        }, {}) || {};
    console.log("PARAMS", params);
    console.log("PATH ", path);

    return { routes: [{ name: path.replace("/auth/", ""), params }] };
  },
};

export default linking;
